import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LoadScript } from "@react-google-maps/api";

import Header from "./components/Header";
import Footer from "./components/Footer";
import GisLayout from "./pages/GisLayout";

import Dashboard from "./pages/Dashboard";
import AdminDashboard from "./pages/AdminDashboard";
import Expense from "./pages/Expense";
import GisData from "./pages/GisData";
import ResetPassword from "./pages/ResetPassword";
import UserDashboard from "./pages/UserDashboard";
import ContactFeedbackPage from "./pages/ContactFeedbackPage";
import MapPage from "./pages/MapPage";
import ProjectPage from "./pages/ProjectPage";
import ToolPage from "./pages/ToolPage";

const LIBRARIES = ["places", "geometry"];

function App() {
  return (
    <LoadScript
      googleMapsApiKey="AIzaSyCoMjm-QI8zCJ6btkg1GhS-EZnLhz2DaPs"
      libraries={LIBRARIES}
    >
      <Router>
        <Routes>

          {/* 🌐 PUBLIC LANDING */}
          <Route
            path="/"
            element={
              <>
                <Header />
                <Dashboard />
                <Footer />
              </>
            }
          />

          {/* 📩 PUBLIC PAGES */}
          <Route
            path="/reset-password"
            element={
              <>
                <Header />
                <ResetPassword />
                <Footer />
              </>
            }
          />

          <Route
            path="/contact-feedback"
            element={
              <>
                <Header />
                <ContactFeedbackPage />
                <Footer />
              </>
            }
          />

          {/* 🗺️ PUBLIC GIS MODULES (NO LOGIN) */}
          <Route
            path="/gis-data"
            element={
              <GisLayout>
                <GisData />
              </GisLayout>
            }
          />

          <Route
            path="/map"
            element={
              <GisLayout>
                <MapPage />
              </GisLayout>
            }
          />

          <Route
            path="/expense"
            element={
              <GisLayout>
                <Expense />
              </GisLayout>
            }
          />

          <Route
            path="/projects"
            element={
              <GisLayout>
                <ProjectPage />
              </GisLayout>
            }
          />

          <Route
            path="/tool"
            element={
              <GisLayout>
                <ToolPage />
              </GisLayout>
            }
          />

          {/* 👥 PUBLIC ADMIN VIEW (NO AUTH) */}
          <Route
            path="/user-dashboard"
            element={
              <GisLayout>
                <UserDashboard />
              </GisLayout>
            }
          />

          <Route
            path="/admin-dashboard"
            element={
              <GisLayout>
                <AdminDashboard />
              </GisLayout>
            }
          />

        </Routes>
      </Router>
    </LoadScript>
  );
}

export default App;